import { onlineManager } from '@tanstack/react-query'
import { Outlet, createFileRoute } from '@tanstack/react-router'
import z from 'zod/v4'
import { queryKeys } from '@/queries/keys'
import { getBookingQueryOptions } from '@/queries/query'

export const Route = createFileRoute('/manage-booking/$id')({
  params: {
    parse: (params) => ({
      id: z.string().trim().parse(params.id),
    }),
    stringify: ({ id }) => ({ id }),
  },
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return context.queryClient.ensureQueryData(
        getBookingQueryOptions(params.id),
      )
    }
    return context.queryClient.getQueryData(queryKeys.booking.detail(params.id))
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
